export default "__VITE_ASSET__pLVNaqwe__"